<template>
  <div class="pv-status" :class="{'no-spaces' : (table.length === 0 || !table) && !loading}">
    <div class="container-fluid mx-auto px-4">
      <div v-if="loading">
        <p class="pb-5 opacity-50 text-center">Caricamento in corso ...</p>
      </div>
      <div v-else-if="table.length > 0">
        <h2 class="page-title">• SITUAZIONE ORDINI PUNTO VENDITA</h2>
        <!-- MARKETING -->
        <div v-if="isMarketingManager" class="table-wrapper">
          <div class="controls-wrapper">
            <span>
              Filtri:
            </span>
            <input
              v-model="filterItemCode"
              type="text"
              class="border rounded px-3 py-2 w-full sm:w-64"
              placeholder="Filtra Cod. Articolo cliente"
            />
            <input
              v-model="filterDesc"
              type="text"
              class="border rounded px-3 py-2 w-full sm:w-80"
              placeholder="Filtra Desc."
            />
          </div>
          <div class="inner-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Cod. Articolo cliente</th>
                  <th>Desc.</th>
                  <th>Meccanica iniziale Ce.dis.</th>
                  <th>Riproiezione Ce.dis.</th>
                  <th>Giacenza Promotica al {{ table[0].QtyAvailableAt }}*</th>
                  <th>Totale ordinato al {{ table[0].QtyCumulatedAt }} Ce.dis.</th>
                  <th>Totale spedito al {{ table[0].QtyShippedAt }} Ce.dis.</th>
                  <th>Totale da spedire Ce.dis.</th>
                  <th>Data di evasione**</th>
                  <th>Stima data consegna nuovi ordini</th>
                </tr>
              </thead>
              <tbody v-if="visibleRows.length > 0">
                <tr v-for="(row, idx) in visibleRows" :key="idx">
                  <td>{{ row.SubCatNum }}</td>
                  <td class="italic">{{ row.ItemName }}</td>
                  <td>{{ row.U_PR_PROIEZ }}</td>
                  <td>{{ row.PlanQty }}</td>
                  <td>{{ row.QtyAvailable }}</td>
                  <td>{{ row.QtyCumulated }}</td>
                  <td>{{ row.QtyShipped }}</td>
                  <td>{{ row.QtyOpen }}</td>
                  <td>{{ row.DueDate }}</td>
                  <td>
                    <span
                      class="headlight"
                      :class="getColorClass(row.ColorNextDueDate)"
                    >
                      {{ row.NextDueDate }}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="10" class="text-center">Nessun risultato</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- PV -->
        <div v-else class="table-wrapper">
          <div class="controls-wrapper">
            <span>
              Filtri:
            </span>
            <input
              v-model="filterItemCode"
              type="text"
              class="border rounded px-3 py-2 w-full sm:w-64"
              placeholder="Filtra Cod. Articolo cliente"
            />
            <input
              v-model="filterDesc"
              type="text"
              class="border rounded px-3 py-2 w-full sm:w-80"
              placeholder="Filtra Desc."
            />
          </div>
          <div class="inner-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Cod. Articolo cliente</th>
                  <th>Desc.</th>
                  <th>Totale ordinato al {{ table[0].QtyCumulatedAt }}</th>
                  <th>Totale spedito al {{ table[0].QtyShippedAt }}</th>
                  <th>Totale da spedire</th>
                  <th>Data di evasione*</th>
                  <th>Stima data consegna nuovi ordini</th>
                </tr>
              </thead>
              <tbody v-if="visibleRows.length > 0">
                <tr v-for="(row, idx) in visibleRows" :key="idx">
                  <td>{{ row.SubCatNum }}</td>
                  <td class="italic">{{ row.ItemName }}</td>
                  <td>{{ row.QtyCumulated }}</td>
                  <td>{{ row.QtyShipped }}</td>
                  <td>{{ row.QtyOpen }}</td>
                  <td>{{ row.DueDate }}</td>
                  <td>
                    <span
                      class="headlight no-content"
                      :class="getColorClass(row.ColorNextDueDate)"
                    ></span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="10" class="text-center">Nessun risultato</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="legend container mx-auto px-4" v-if="table.length > 0">
      <div class="notes mobile" v-if="isMarketingManager">
        <p>*Giacenza dell'intera operazione (condivisa tra i Ce.dis.)</p>
        <p>**Data prevista per l'evasione completa ordini (consegna a Ce.dis.)</p>
      </div>
      <div class="notes mobile" v-else>
        <p>*Data prevista per l'evasione completa ordini (consegna a Ce.dis.)</p>
      </div>
      <div class="headlight-group">
        <div class="headlight-wrapper">
          <div>
            <span class="headlight no-content bg-primary-green"></span>
          </div>
          <div class="text-wrapper">
            <b>VERDE</b>
            <p>prodotto disponibile</p>
          </div>
        </div>
        <div class="headlight-wrapper">
          <div>
            <span class="headlight no-content bg-primary-yellow"></span>
          </div>
          <div class="text-wrapper">
            <b>GIALLO</b>
            <p>prodotto non disponibile ma in arrivo</p>
          </div>
        </div>
        <div class="headlight-wrapper">
          <div>
            <span class="headlight no-content bg-primary-red"></span>
          </div>
          <div class="text-wrapper">
            <b>ROSSO</b>
            <p>prodotto non disponibile, in ordinazione</p>
          </div>
        </div>
      </div>
      <div class="notes desktop" v-if="isMarketingManager">
        <p>*Giacenza dell'intera operazione (condivisa tra i Ce.dis.)</p>
        <p>**Data prevista per l'evasione completa ordini (consegna a Ce.dis.)</p>
      </div>
      <div class="notes desktop" v-else>
        <p>*Data prevista per l'evasione completa ordini (consegna a Ce.dis.)</p>
      </div>
    </div>
    <!-- <span class="disclaimer" v-if="table.length > 0 && !loading">
      <b>ATTENZIONE:</b> Le consegne avvengono al 1° e al 3° lunedì del mese
    </span> -->
  </div>
</template>

<script>
export default {
  props: ['campData', 'extraData'],
  data () {
    return {
      loading: true,
      table: [],
      filterItemCode: '',
      filterDesc: ''
    }
  },
  computed: {
    isMarketingManager () {
      return this.extraData?.marketing_manager
    },
    filteredTable () {
      let t = this.table
      if (this.filterItemCode) {
        const q = this.filterItemCode.toLowerCase()
        t = t.filter(r => String(r.ItemCode || '').toLowerCase().includes(q))
      }
      if (this.filterDesc) {
        const qd = this.filterDesc.toLowerCase()
        t = t.filter(r => String(r.ItemName || '').toLowerCase().includes(qd))
      }
      return t
    },
    visibleRows () {
      return this.filteredTable
    }
  },
  mounted () {
    this.getPVStatus()
  },
  methods: {
    getColorClass (color) {
      switch (color) {
        case '1 - Green':
          return 'bg-primary-green'
        case '2 - Yellow':
          return 'bg-primary-yellow'
        case '3 - Red':
          return 'bg-primary-red'
        default:
          return 'bg-primary-gray'
      }
    },
    async getPVStatus () {
      const portalPayload = {
        agreement_no: this.campData.agreement_no,
        card_code: this.campData.bp_code
      }
      await this.$store.dispatch('readOrdersPortal', portalPayload)
        .then((rsp) => {
          if (process.env.NODE_ENV === 'development') {
            console.log('---READ ORDERS PORTAL', rsp)
          }
          this.table = rsp
        })

      setTimeout(() => {
        this.loading = false
      }, 2000)
    }
  }
}
</script>

<style scoped lang="scss">
  @use "@/assets/scss/pvstatus.scss";
</style>
